import React, { useState } from 'react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'terms' | 'privacy' | null>(null);
  return <footer className="text-center py-10 px-5 text-xs leading-8" style={{
    background: 'var(--ink)',
    color: 'rgba(255,255,255,.3)'
  }} data-id="element-73">
      <p data-id="element-74">
        © 2026 Kit Digital de Liberación Emocional · 33 Rituales para Soltar el
        Pasado
      </p>
      <p className="mt-2" data-id="element-75">
        <button onClick={() => setActiveModal('terms')} className="no-underline bg-transparent border-none cursor-pointer font-inherit text-xs leading-8 hover:underline" style={{
        color: 'rgba(255,255,255,.45)'
      }} data-id="element-76">
          Términos y condiciones
        </button>{' '}
        ·{' '}
        <button onClick={() => setActiveModal('privacy')} className="no-underline bg-transparent border-none cursor-pointer font-inherit text-xs leading-8 hover:underline" style={{
        color: 'rgba(255,255,255,.45)'
      }} data-id="element-77">
          Política de privacidad
        </button>
      </p>
      <p className="mt-4 max-w-[480px] mx-auto text-[11px] leading-relaxed" style={{
      opacity: 0.55
    }} data-id="element-78">
        Este producto es un kit digital de herramientas de apoyo emocional. No
        reemplaza la atención psicológica o psiquiátrica profesional. Si estás
        atravesando una crisis de salud mental, por favor consultá a un
        profesional.
      </p>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-[9999] flex items-center justify-center p-5" style={{
      background: 'rgba(45,31,43,.85)',
      backdropFilter: 'blur(6px)'
    }} onClick={() => setActiveModal(null)} data-id="element-79">
          <div className="relative w-full max-w-[600px] max-h-[80vh] overflow-y-auto rounded-2xl p-8 md:p-10 text-left" style={{
        background: 'var(--white)',
        boxShadow: '0 24px 64px rgba(0,0,0,.3)'
      }} onClick={e => e.stopPropagation()} data-id="element-80">
            {/* Close button */}
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center border-none cursor-pointer text-lg leading-none" style={{
          background: 'var(--blush)',
          color: 'var(--ink)'
        }} data-id="element-81">
              ×
            </button>

            <h3 className="font-serif font-medium mb-6" style={{
          fontSize: '24px',
          color: 'var(--ink)'
        }} data-id="element-82">
              {activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'}
            </h3>

            <div className="text-[14px] leading-relaxed space-y-4" style={{
          color: 'var(--muted)'
        }} data-id="element-83">
              {activeModal === 'terms' ? <>
                  <p data-id="element-84">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-85">
                      1. Aceptación de los términos
                    </strong>
                  </p>
                  <p data-id="element-86">
                    Al adquirir el Kit Digital "33 Rituales para Soltar el
                    Pasado", aceptás estos términos y condiciones en su
                    totalidad. Si no estás de acuerdo con alguno de estos
                    términos, te pedimos que no realices la compra.
                  </p>

                  <p data-id="element-87">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-88">
                      2. Producto digital
                    </strong>
                  </p>
                  <p data-id="element-89">
                    Este producto es un kit digital descargable en formato PDF.
                    Una vez realizada la compra, recibirás acceso inmediato al
                    material a través de un enlace de descarga enviado a tu
                    correo electrónico.
                  </p>

                  <p data-id="element-90">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-91">
                      3. Uso personal
                    </strong>
                  </p>
                  <p data-id="element-92">
                    El contenido del kit es para uso personal y exclusivo del
                    comprador. Queda prohibida la reproducción, distribución,
                    reventa o compartición del material sin autorización
                    expresa.
                  </p>

                  <p data-id="element-93">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-94">
                      4. Garantía de devolución
                    </strong>
                  </p>
                  <p data-id="element-95">
                    Ofrecemos una garantía de devolución de 7 días desde la
                    fecha de compra. Si no estás satisfecha con el producto,
                    podés solicitar el reembolso completo dentro de ese plazo
                    sin necesidad de justificación.
                  </p>

                  <p data-id="element-96">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-97">
                      5. Limitación de responsabilidad
                    </strong>
                  </p>
                  <p data-id="element-98">
                    Este producto es una herramienta de apoyo emocional y no
                    reemplaza la atención psicológica o psiquiátrica
                    profesional. No nos hacemos responsables por los resultados
                    individuales de cada usuario.
                  </p>

                  <p data-id="element-99">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-100">
                      6. Propiedad intelectual
                    </strong>
                  </p>
                  <p data-id="element-101">
                    Todo el contenido del kit, incluyendo textos, diseños y
                    metodologías, está protegido por derechos de autor.
                    Cualquier uso no autorizado será perseguido legalmente.
                  </p>
                </> : <>
                  <p data-id="element-102">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-103">
                      1. Información que recopilamos
                    </strong>
                  </p>
                  <p data-id="element-104">
                    Recopilamos únicamente la información necesaria para
                    procesar tu compra: nombre, dirección de correo electrónico
                    y datos de pago. No almacenamos información de tarjetas de
                    crédito.
                  </p>

                  <p data-id="element-105">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-106">
                      2. Uso de la información
                    </strong>
                  </p>
                  <p data-id="element-107">
                    Tu información personal se utiliza exclusivamente para:
                    procesar tu pedido, enviarte el material adquirido y
                    comunicarnos contigo en caso de ser necesario respecto a tu
                    compra.
                  </p>

                  <p data-id="element-108">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-109">
                      3. Protección de datos
                    </strong>
                  </p>
                  <p data-id="element-110">
                    Implementamos medidas de seguridad técnicas y organizativas
                    para proteger tu información personal contra acceso no
                    autorizado, alteración o destrucción.
                  </p>

                  <p data-id="element-111">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-112">
                      4. Compartición con terceros
                    </strong>
                  </p>
                  <p data-id="element-113">
                    No vendemos, intercambiamos ni transferimos tu información
                    personal a terceros. La única excepción son los proveedores
                    de servicios de pago necesarios para procesar tu
                    transacción.
                  </p>

                  <p data-id="element-114">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-115">
                      5. Cookies
                    </strong>
                  </p>
                  <p data-id="element-116">
                    Nuestro sitio puede utilizar cookies para mejorar tu
                    experiencia de navegación. Podés configurar tu navegador
                    para rechazar cookies, aunque esto podría afectar algunas
                    funcionalidades.
                  </p>

                  <p data-id="element-117">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-118">
                      6. Tus derechos
                    </strong>
                  </p>
                  <p data-id="element-119">
                    Tenés derecho a acceder, rectificar o eliminar tu
                    información personal en cualquier momento. Para ejercer
                    estos derechos, contactanos a través de nuestro correo
                    electrónico.
                  </p>

                  <p data-id="element-120">
                    <strong style={{
                color: 'var(--ink)',
                fontWeight: 500
              }} data-id="element-121">
                      7. Cambios en la política
                    </strong>
                  </p>
                  <p data-id="element-122">
                    Nos reservamos el derecho de actualizar esta política de
                    privacidad en cualquier momento. Los cambios serán
                    publicados en esta página.
                  </p>
                </>}
            </div>
          </div>
        </div>}
    </footer>;
}